import { DBO_GAME } from '@op/utils/format';
import { useEffect, useState } from 'react';
import { getLocale, useIntl } from 'umi';

export default function usePageName({
  name,
  listMenu,
  menuId,
  defaultSourceType = 'menu',
  parentPageName,
}: {
  name?: string;
  listMenu: Array<any>;
  menuId?: string;
  defaultSourceType?: 'page' | 'menu';
  parentPageName?: string;
}) {
  const { formatMessage } = useIntl();
  const [pageName, setPageName] = useState('');
  const [itemMenuId, setItemMenuId] = useState('');
  const [sourceType, setSourceType] = useState('');
  const [loading, setLoading] = useState(true);
  const [hasMenu, setHasMenu] = useState(false);

  useEffect(() => {
    setLoading(true);
    let item: any = {};
    if (menuId) {
      item = DBO_GAME.findMenu(listMenu, menuId, {
        key: 'id',
        parentMenuName: parentPageName,
      });
    } else if (name) {
      item = DBO_GAME.findMenu(listMenu, decodeURIComponent(name));
    }
    const isEn = getLocale() === 'en-US';

    setPageName((isEn ? item?.name_en : item?.name_cn) || name);
    setItemMenuId(item?.id);
    setSourceType(item?.source_type || defaultSourceType);
    setLoading(false);
    setHasMenu(!!item?.id);
  }, [name, listMenu, formatMessage, menuId]);

  return {
    pageName,
    findLoading: loading,
    menuId: itemMenuId,
    sourceType,
    hasMenu,
  };
}
